import React from "react";
import { ArrowRight, MapPin } from "lucide-react";

// Small cross-promo divider linking to the sister app, SJDS.app.
// Self-hosted logo (/brand/sjds-logo.png) so the preview never breaks.
const C = {
  en: { eyebrow: "Sister site", title: "Are you in San Juan del Sur?", before: "Visit ", after: " — live surf, tides, weather & community for SJDS.", cta: "Visit" },
  es: { eyebrow: "Sitio hermano", title: "¿Estás en San Juan del Sur?", before: "Visita ", after: " — surf en vivo, mareas, clima y comunidad para SJDS.", cta: "Visitar" },
  fr: { eyebrow: "Site jumeau", title: "Êtes-vous à San Juan del Sur ?", before: "Visitez ", after: " — surf en direct, marées, météo et communauté pour SJDS.", cta: "Visiter" },
  de: { eyebrow: "Schwesterseite", title: "Bist du in San Juan del Sur?", before: "Besuche ", after: " — Live-Surf, Gezeiten, Wetter & Community für SJDS.", cta: "Besuchen" },
  zh: { eyebrow: "姊妹站点", title: "你在圣胡安德尔苏尔吗？", before: "访问 ", after: " —— SJDS 的实时冲浪、潮汐、天气与社区。", cta: "访问" },
  it: { eyebrow: "Sito gemello", title: "Sei a San Juan del Sur?", before: "Visita ", after: " — surf in diretta, maree, meteo e community per SJDS.", cta: "Visita" },
  ru: { eyebrow: "Родственный сайт", title: "Вы в Сан-Хуан-дель-Сур?", before: "Зайдите на ", after: " — сёрф в реальном времени, приливы, погода и сообщество SJDS.", cta: "Открыть" },
};

export default function SjdsCrossPromo({ lang = "en" }) {
  const c = C[lang] || C.en;
  return (
    <div className="relative py-2" data-testid="sjds-crosspromo">
      {/* Hairline divider with a centered pin */}
      <div className="flex items-center gap-3 mb-4" aria-hidden>
        <span className="h-px flex-1 bg-[color:var(--ink-2)]/15" />
        <MapPin className="w-4 h-4 text-[color:var(--coral)]" />
        <span className="h-px flex-1 bg-[color:var(--ink-2)]/15" />
      </div>

      <a
        href="https://sjds.app"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sjds-crosspromo-link"
        className="group flex items-center gap-4 rounded-3xl p-4 sm:p-5 border border-[color:var(--ink-2)]/10 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all"
        style={{ background: "linear-gradient(135deg, #1B3B6F 0%, #264653 100%)", color: "#fff" }}
      >
        <img
          src="/brand/sjds-logo.png"
          alt="SJDS.app logo"
          data-testid="sjds-crosspromo-logo"
          className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl object-cover shrink-0 shadow-md group-hover:rotate-[-3deg] transition-transform"
          style={{ background: "#FDFBF7" }}
        />
        <div className="flex-1 min-w-0">
          <p className="text-[11px] uppercase tracking-[0.18em] text-white/70">{c.eyebrow}</p>
          <p className="text-lg sm:text-xl font-bold leading-tight" style={{ fontFamily: "Outfit" }}>
            {c.title}
          </p>
          <p className="text-sm text-white/85 mt-0.5">
            {c.before}<span className="font-semibold">www.SJDS.app</span>{c.after}
          </p>
        </div>
        <span className="inline-flex items-center gap-1.5 pill px-4 py-2.5 text-sm font-bold shrink-0 shadow-sm group-hover:scale-[1.03] transition-transform" style={{ background: "#fff", color: "#1B3B6F" }}>
          {c.cta}
          <ArrowRight className="w-4 h-4" />
        </span>
      </a>
    </div>
  );
}
